import { create } from "zustand";

export type ProcessDetailFieldItem = {
  label?: string;
  value?: string;
  linkUrl?: string;
};

export type ProcessDetailMessagePayload = {
  basicInfoFields?: ProcessDetailFieldItem[];
  [key: string]: unknown;
};

type ProcessMessageStore = {
  processDetailMessageData?: ProcessDetailMessagePayload;
  setProcessDetailMessage: (params: ProcessDetailMessagePayload) => void;
};

export const useProcessMessageStore = create<ProcessMessageStore>((set) => ({
  processDetailMessageData: undefined,
  setProcessDetailMessage(data) {
    const basicInfoFields = Array.isArray(data?.basicInfoFields)
      ? data.basicInfoFields
      : [];
    set(() => ({
      processDetailMessageData: {
        ...data,
        basicInfoFields,
      },
    }));
  },
}));
